<!--
 * @Author: guoyu
 * @Date: 2020-04-28 18:22:21
 * @LastEditors: your name
 * @LastEditTime: 2020-06-17 11:46:36
 * @Description: 綜合評分解釋彈窗
 -->
<template>
  <component v-model="popupShow" :is="popupType" :score="score" :isGood="isGood" @closeScorePopupStatus="$emit('closeScorePopupStatus')"></component>
</template>
<script>
import ScoreCExplain from "./score1-explain-popup"; 
import ScoreBExplain from "./score2-explain-popup";
export default {
  components: {
    ScoreCExplain,
    ScoreBExplain,
  },
  model: {
    event: "close",
    prop: "show",
  },
  computed: {
    popupShow: {
      get() {
        return this.show;
      },
      set(newVal) {
        this.$emit("close", newVal);
      },
    },
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    isGood: {
      type: Boolean,
      default: false,
    },
    popupType: {
      type: String,
      default: "ScoreCExplain",
    },
    score: { type: [Number, String], default: 0 },
  },
  watch: {
    // 弹窗弹起时禁止滚动body
    show(newVal) {
      let body = document.getElementsByTagName("body")[0];
      if (newVal) {
        body.style.overflow = "hidden";
      } else {
        body.style.overflow = "";
      }
    },
  }
};
</script>
